<template>
  <Dialog 
    v-model:visible="isVisible" 
    :modal="true"
    :closable="false"
    :showHeader="false"
    :style="{ width: '300px' }"
  >
    <div class="p-4 text-center">
      <ProgressSpinner 
        style="width: 50px; height: 50px"
        strokeWidth="4"
        animationDuration="3s"
      />
      <p v-if="currentMessage" class="mt-3 text-600">{{ currentMessage }}</p>
    </div>
  </Dialog>
</template>

<script setup lang="ts">

import { ref } from 'vue'

// Props opcionales
interface Props {
  message?: string
}

const props = withDefaults(defineProps<Props>(), {
  message: ''
})

// Estado interno
const isVisible = ref(false)
const currentMessage = ref('')

// Métodos públicos expuestos para uso externo
function show(message?: string) {
  currentMessage.value = message || props.message
  isVisible.value = true
}

function hide() {
  isVisible.value = false
  currentMessage.value = ''
}

// Exponer métodos para que puedan ser llamados desde el componente padre
defineExpose({
  show,
  hide
})
</script>

<style scoped>
/* Estilos para el spinner centrado */
.p-4 {
  padding: 1.5rem;
}

.text-center {
  text-align: center;
}
</style>